import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { getCurrentDateLocal, formatDateLocal } from '@/utils/common';

interface TransportRosterState {
  // State
  selectedDate: string;
  transportRosterList: any; // Using any to handle any API response structure
  loading: boolean;
  error: string | null;

  // Actions
  setSelectedDate: (date: string | Date | null) => void;
  setTransportRosterList: (data: unknown) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const initialState = {
  selectedDate: getCurrentDateLocal(),
  transportRosterList: null,
  loading: false,
  error: null
};

export const useTransportRosterStore = create<TransportRosterState>()(
  devtools(
    set => ({
      ...initialState,

      setSelectedDate: (date: string | Date | null) => {
        let formattedDate: string;

        if (date === null) {
          formattedDate = getCurrentDateLocal();
        } else if (date instanceof Date) {
          formattedDate = formatDateLocal(date);
        } else {
          formattedDate = date;
        }

        set({ selectedDate: formattedDate }, false, 'setSelectedDate');
      },

      setTransportRosterList: (data: unknown) => {
        set({ transportRosterList: data });
      },

      setLoading: (loading: boolean) => {
        set({ loading }, false, 'setLoading');
      },

      setError: (error: string | null) => {
        set({ error }, false, 'setError');
      },

      reset: () => {
        set(initialState, false, 'reset');
      }
    }),
    {
      name: 'transport-roster-store'
    }
  )
);
